exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".basic-6d918696{font-size:16px;cursor:pointer;margin-left:2px}.premium-3e9ff33e{font-size:16px;cursor:pointer;margin-left:2px}\n", ""]);

// Exports
exports.locals = {
	"basic": "basic-6d918696",
	"premium": "premium-3e9ff33e"
};